<template>
	<div class="view-wrapper not-found" v-if="document">
		<div class="container">
			<img class="not-found__image" :src="this.randomFailGif">
			<h1>{{ document.title }}</h1>
			<div>
				<c-flex-content :content="document.flex_content" />
			</div>
		</div>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import get404Data from '@/api/404.wp.api'
import CFlexContent from '@/components/FlexContent'

export default {
	name: 'notfound',
	components: {
		CFlexContent
	},
	data: () => ({
		documentData: {},
		headData: defaultHeadData,
		bgGifs: [
			'https://media.giphy.com/media/VaF9lILgn2ta/giphy.gif',
			'https://media.giphy.com/media/bqW3e5uzX4McE/giphy.gif',
			'https://media.giphy.com/media/3oKIPAKenYskqXzYnC/giphy.gif',
			'https://media.giphy.com/media/On2Tz5jzQgr3W/giphy.gif',
			'https://media.giphy.com/media/s0wexKpI9qWiY/giphy.gif'
		]
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		},
		randomFailGif() {
			let g = this.bgGifs[Math.floor(Math.random()*this.bgGifs.length)];
			return g;
		}
	},
	watch: {
		'$route': function() {
			this.set404Data()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: false })
		}
	},
	beforeMount() {
		this.set404Data()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/404' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/404' })

	},
	methods: {
		set404Data() {
			this.documentData = null
			get404Data({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl,
					prerenderStatusCode: '404',
					robots: 'noindex, nofollow'
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.not-found {
		margin-top: -2rem;
		position: relative;
		padding-bottom: 6rem;

		.container {
			text-align: center;

			h1 {
				width: 18rem;
				transform: skewY(-4deg);
				font-size: 5rem;
				margin: -2rem auto 4rem auto;
				position: relative;
				z-index: 1;
				color: #fff;
				padding: .5rem 0 1.2rem 0;
				background-color: $colorBrandMain;
			}
			h2 {
				font-size: 1.5rem;
				max-width: 40rem;
				margin: 0 auto;
				line-height: 1.6;
			}
			a {
				text-decoration: none;
				color: $colorGray;

				&:hover {
					color: $colorBrandSecondary;
				}
			}
		}
		&__image {
			display: block;
			width: 100%;
			max-width: 45rem;
			margin: 0 auto;
		}

		@include mq($to: medium) {
			margin-top: 2rem;
			padding-bottom: 4rem;

			.container {

				h1 {
					font-size: 3rem;
					width: 10rem;
					margin: -1rem auto 2rem auto;
				}
				h2 {
					font-size: 1rem;
					line-height: 1.5;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// NotFound.vue?28b6d9ac